module.exports = __webpack_public_path__ + "fonts/lato-italic-webfont.8b8055de.ttf";